import * as Yup from "yup";

export const defectSchema = Yup.object({
    defect: Yup.string().required("Enter Defect"),
    category: Yup.string().required("Select Category"),
    remark: Yup.string().required("Select Remark"),
    status: Yup.string().required("Select Status"),
    // password: Yup.string().required(" Enter Password"),
});
